import languageFilterOptions from 'conf/platformLanguages';
import moment from 'moment';

// Actions
export const CHANGE_LANGUAGE_FILTER =
  'UI/PLATFORM_USAGE/PAGE_VIEWS/CHANGE_LANGUAGE_FILTER';
export const SET_LANGUAGE_FILTER =
  'UI/PLATFORM_USAGE/PAGE_VIEWS/SET_LANGUAGE_FILTER';
export const CHANGE_PAGE = 'UI/PLATFORM_USAGE/CHANGE_PAGE';
export const SET_CHART_OPTION = 'UI/PLATFORM_USAGE/LINE_CHART/SET_CHART_OPTION';
export const SET_LIMIT = 'UI/PLATFORM_USAGE/PAGE_VIEWS/SET_LIMIT';
export const TOGGLE_LANGUAGE_FILTER_DROPDOWN =
  'UI/PLATFORM_USAGE/PAGE_VIEWS/TOGGLE_LANGUAGE_FILTER_DROPDOWN';
export const TOGGLE_LIMIT_DROPDOWN =
  'UI/PLATFORM_USAGE/PAGE_VIEWS/TOGGLE_LIMIT_DROPDOWN';
export const TOGGLE_OPTION_DROPDOWN =
  'UI/PLATFORM_USAGE/LINE_CHART/TOGGLE_OPTION_DROPDOWN';
export const CHANGE_DATE = 'UI/PLATFORM_USAGE/CHANGE_DATE';
export const TOGGLE_DATEPICKER_DROPDOWN =
  'UI/PLATFORM_USAGE/TOGGLE_DATEPICKER_DROPDOWN';
export const SET_GROUP_FILTER = 'UI/PLATFORM_USAGE/SET_GROUP_FILTER';

/*** Action Creators ***/

export const setChartOption = (chartOption) => ({
  type: SET_CHART_OPTION,
  chartOption
});

export const toggleOptionsDropdown = () => ({
  type: TOGGLE_OPTION_DROPDOWN
});

export const changePage = (page) => ({
  type: CHANGE_PAGE,
  page
});

export const toggleLimitDropdown = () => ({
  type: TOGGLE_LIMIT_DROPDOWN
});

export const setLimit = (limit) => ({
  type: SET_LIMIT,
  limit
});

export const toggleLanguageFilterDropdown = () => ({
  type: TOGGLE_LANGUAGE_FILTER_DROPDOWN
});

export const changeLanguageFilter = (languageFilter) => ({
  type: CHANGE_LANGUAGE_FILTER,
  languageFilter
});

export const setLanguageFilter = (languageFilter) => ({
  type: SET_LANGUAGE_FILTER,
  languageFilter
});

export const changeDate = ({ startDate, endDate }) => ({
  type: CHANGE_DATE,
  startDate,
  endDate
});

export const toggleDatepickerDropdown = () => ({
  type: TOGGLE_DATEPICKER_DROPDOWN
});

export const setGroupFilter = (groupFilter) => ({
  type: SET_GROUP_FILTER,
  groupFilter
});

/*** Reducer ***/
export const DEFAULT_STATE = {
  chartOption: 0,
  limit: 10,
  page: 0,
  languageFilter: 'en',
  languageFilterOptions,
  chartOptionDropdownOpen: false,
  limitDropdownOpen: false,
  languageFilterDropdownOpen: false,
  datepickerDropdownOpen: false,
  startDate: new moment().subtract(7, 'd'),
  endDate: new moment().subtract(1, 'd'),
  utcOffset: (new moment().utcOffset() / 60).toFixed(2),
  groupFilter: { id: '' }
};

export default function PlaformUsageReducer(
  state = DEFAULT_STATE,
  {
    type,
    limit,
    chartOption,
    page,
    languageFilter,
    startDate,
    endDate,
    groupFilter
  } = {}
) {
  const {
    limitDropdownOpen,
    languageFilterDropdownOpen,
    chartOptionDropdownOpen,
    datepickerDropdownOpen
  } = state;
  switch (type) {
    case CHANGE_PAGE:
      return {
        ...state,
        page
      };
    case TOGGLE_OPTION_DROPDOWN:
      return {
        ...state,
        chartOptionDropdownOpen: !chartOptionDropdownOpen
      };
    case SET_CHART_OPTION:
      return {
        ...state,
        chartOption
      };
    case TOGGLE_LIMIT_DROPDOWN:
      return {
        ...state,
        limitDropdownOpen: !limitDropdownOpen
      };
    case SET_LIMIT:
      return {
        ...state,
        limit,
        page: 0
      };
    case TOGGLE_LANGUAGE_FILTER_DROPDOWN:
      return {
        ...state,
        languageFilterDropdownOpen: !languageFilterDropdownOpen
      };
    case SET_LANGUAGE_FILTER:
      return {
        ...state,
        languageFilter
      };
    case CHANGE_LANGUAGE_FILTER:
      return {
        ...state,
        languageFilter,
        page: 0
      };
    case CHANGE_DATE:
      return {
        ...state,
        startDate,
        endDate,
        utcOffset: (new moment().utcOffset() / 60).toFixed(2)
      };
    case TOGGLE_DATEPICKER_DROPDOWN:
      return {
        ...state,
        datepickerDropdownOpen: !datepickerDropdownOpen
      };
    case SET_GROUP_FILTER: {
      return {
        ...state,
        groupFilter
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/actions/platformUsage/actions.js